import JobPostForm from './JobPostForm';
import ActiveArchiveToggle from '@/components/Filters/ActiveArchiveToggle';
import AdminSearchBox from '@/components/Admin/reusableComponents/AdminSearchBox';

const JobPostFilters = ({
    onSearch = () => {},
    inputRef,
    isActive,
    setIsActive = () => {},
    fetchOnAction,
    loading,
    teamDetails,
}) => {
    return (
        <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex gap-2">
                <AdminSearchBox search={undefined} onSearch={onSearch} placeholder={'Search...'} inputRef={inputRef} />
            </div>
            <div className="d-flex gap-2">
                <div className="mr-4">
                    <ActiveArchiveToggle isActive={isActive} setIsActive={setIsActive} disabled={loading} />
                </div>
                <JobPostForm mode="create" onCreate={() => fetchOnAction(1)} teamDetails={teamDetails} />
            </div>
        </div>
    );
};
export default JobPostFilters;
